import { useEffect, useState } from "react";
const debounce = (func, delay) => {
  let timeoutId;
  return function (...args) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func(args);
    }, delay);
  };
};

export const useInfiniteScroll = (fetchData, limit, totalCount) => {
  const [page, setPage] = useState(0);

  const resetPage = () => {
    setPage(0);
  };

  const handleScroll = debounce(() => {
    const bottom =
      Math.ceil(window.innerHeight + window.scrollY) >=
      document.documentElement.scrollHeight - 200;

    if (bottom) {
      setPage((prevPage) => {
        const nextPage = prevPage + 1;
        console.log("limit", limit, "offset", nextPage * limit);
        if (totalCount <= nextPage * limit) {
          return nextPage - 1; // No more data to fetch , skip incrementing page
        }
        fetchData(nextPage * limit, limit);
        return nextPage;
      });
    }
  }, 300);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [totalCount]);

  return { resetPage };
};
